export const GET_TRANSACTIONS = 'GET_TRANSACTIONS';
export const GET_TRANSACTIONS_SUCCESS = 'GET_TRANSACTIONS_SUCCESS';
export const GET_TRANSACTIONS_ERROR = 'GET_TRANSACTIONS_ERROR';
export const GET_TRANSACTIONS_SUMMARY = 'GET_TRANSACTIONS_SUMMARY';
export const GET_TRANSACTIONS_SUMMARY_SUCCESS = 'GET_TRANSACTIONS_SUMMARY_SUCCESS';
export const GET_TRANSACTIONS_SUMMARY_ERROR = 'GET_TRANSACTIONS_SUMMARY_ERROR';

export const getTransactions = () => ({
  type: GET_TRANSACTIONS,
});

export const getTransactionsSummary = () => ({
  type: GET_TRANSACTIONS_SUMMARY,
});
